'use strict';
(function($){
	/*
	 * Vetology.CaseLink widget
	 *
	 * @description This is the main Vetology CaseLink widget that needs a description right here
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.CaseLink',
		{
			"options": {
			},
			/*
			 * Vetology.CaseLink._init
			 *
			 * @description	Initializes the Vetology.CaseLink
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o._eventHandler();
			},
			/*
			 * Vetology.CaseLink._eventHandler
			 *
			 * @description	Placeholder for a method
			 *
			 * @return NULL
			 *
			 */
			"_eventHandler": function(){
				var o = this;
				$(window).resize(function(){
					o._setMerging();
				});
				$('body').on('click', '.reviewMerge', function(e){
					e.preventDefault();
					var mergeMain = $(this).closest('.caseDrag');
					var data = {caseMergeID: mergeMain.data('item')};
					doAjax(
						'GET',
						data,
						'/ca/lsc',
						function(html){
							$('.vetologyModal').find('.modal-body').html(html);
							$('.vetologyModal').modal();
						},
						'HTML'
					);
					
				});
				$('body').on('click', '.break_manual_link', function(e){
					e.preventDefault();
					var mergeMain = $(this).closest('.caseDrag');
					var data = {caseMergeID: mergeMain.data('item')};
					doAjax(
						'GET',
						data,
						'/ca/lsc',
						function(html){
							$('.vetologyModal').find('.modal-body').html(html);
							$('.vetologyModal').modal();
						},
						'HTML'
					);
					
				});
				$('body').on('click', '.case_mergeRemove', function(e){
					e.preventDefault();
					$('.popover').remove();
					o._unMerge($(this).closest('.caseMerged'));
				});
				$(document).ajaxComplete(function () {
					o._setMerging();
                    $("popover.setCasesFilter[data-toggle=popover]").popover();
                });
                o._unLink = o._unLink.bind(o);
				$('body').on('click', '.linked .vetology-unlink', function(e) {
				    o._unLink(e.currentTarget);
                });
				o._setMerging();
			},
			/*
			 * Vetology.CaseLink._unMerge
			 *
			 * @description	Placeholder for a method
			 *
			 * @return NULL
			 *
			 */
			"_unMerge": function(item){
				$('.popover').remove();
				var unmergeURL = item.data('clinic') != mergeMain.data('clinic') ? '/ca/ulac' : '/ca/ulsc';
				var data = {
					mergeID		: item.data('item'),
					unmergeOn	: mergeMain.data('item')
				};
				$("body").Vetology("doRequest", "POST", data, unmergeURL, function(is){
					if(is.unmerged){
						$("body").Vetology("vetologyShowDialog", "Success:", is.reason, "success");
						mergeMain.data('merges', mergeMain.data('merges') - 1);
						var modalities = mergeMain.find('.case_modality').html().replace(/(\r\n|\n|\r)/gm,"").split(', ');
						var modalities2 = item.find('.case_modality').html().replace(/(\r\n|\n|\r)/gm,"").split(', ');
						modalities = modalities.concat(modalities2);
						modalities = arrayUnique(modalities);
						var itemImageSeries = item.find('.case_imageAmount').html().split(':');
						var droppableImageSeries = mergeMain.find('.case_imageAmount').html().split(':');
						if(parseInt(itemImageSeries[1]) > 0 && parseInt(droppableImageSeries[0]) == 0){
							var src = item.find('img').attr('src');
							mergeMain.find('img').attr('src', src);
						}
						mergeMain.find('.case_imageAmount').html(
							(parseInt(droppableImageSeries[0]) + parseInt(itemImageSeries[0])) + 
							':' + 
							(parseInt(droppableImageSeries[1]) + parseInt(itemImageSeries[1]))
						);
						mergeMain.find('.case_modality').html(modalities.join(', '));
						item.hide('slow', function(){ item.remove(); });
						mergeMain.addClass('IGotMerges');
						mergeMain.find('.mergeAmount').html('<span class="badge">' + mergeMain.data('merges') + '</span>');
						$(".isFilter").trigger("change");
					} else {
						$("body").Vetology("vetologyShowDialog", is.reasonTitle, is.reason, "error");
					}
				}, "JSON", false, "Please wait while I unlink our case", "Please wait while I unlink our case<br>", "I am almost done");
			},
			/*
			 * Vetology.CaseLink._merge
			 *
			 * @description	Placeholder for a method
			 *
			 * @return NULL
			 *
			 */
			"_merge": function($draggable, d, clone){
                const o = this;
				var data = {
					target	: d.data('case'),
					case	: $draggable.data('case'),
				};
				var linkCountTarget = d.find('.link-count');
				var linkCountTarget2 = $draggable.find('.link-count');
				$("body").Vetology("doRequest", "POST", data, '/worklist/clinic/link-case', function(json){
					if(json.error){
						$("body").Vetology("vetologyShowDialog", "Error:", json.reason, "error");
						clone.remove();
						$draggable.attr('style', '').removeClass('isDragging');
						$('body')
							.removeClass('draggingMerge')
							.find('.isDroppable .overlay').remove();
					} else {
                        $(".isFilter").trigger("change");
                        setTimeout(() => {
                            $("body").Vetology("vetologyShowDialog", "Success:", "Cases successfully linked", "success");
                        }, 2000);

					}
				}, "JSON", false, "Please wait while I link your cases", "Please wait while I link your cases<br>I am almost done");
			},

            "createVetologyView": function(data) {
                const popover = document.createElement('span');
                popover.classList.add('vetology-view', 'setCasesFilter', 'related-cases-popover', 'pop_content');
                popover.dataset.case_id = data.caseID;
                popover.dataset.cases = data.cases;
                popover.dataset.toggle = 'popover';
                popover.dataset.placement = 'bottom';
                popover.dataset.trigger = 'hover';
                popover.dataset.html = 'true';
                popover.dataset.container = 'body';
                popover.dataset.content = data.content;
                popover.attributes.title = 'Related cases';
                return popover;
            },

			/*
			 * Vetology.CaseLink._setMerging
			 *
			 * @description	Placeholder for a method
			 *
			 * @return NULL
			 *
			 */
			"_setMerging": function(){
				var o = this;
				$('body').on('change', 'select.caseModality', function(){
					var modality = $(this).val();
					if(modality != $(this).data('modality')){
						$("body").Vetology("vetologyShowDialog", "Attention:", "You have selected a modality other than the one of the main case, the main case with ID " + $(this).data("item") + " will not be included", "warning");
					}
					$('.mergedModalityUpdate > div').addClass('isNotActiveModality').removeClass('isActiveModality');
					$('.mergedModalityUpdate > div').each(function(){
						if(modality == $(this).data('modality')){
							$(this).removeClass('isNotActiveModality').addClass('isActiveModality');
						}
					});
				});
				$('.case_linker').each(function(el){
					var el = $(this);
					if(!el.hasClass('isDragInit')){
						el.addClass('isDragInit');
						var dragParent = el.closest('.isDraggable');
						dragParent.draggable(
							{
								revert	: true,
								appendTo: 'body',
								greedy	: true,
								handle	: el,
								start	: function(){
									var droppables = $('body').find('.isDroppable');
									$.each(droppables, function(i,d){
										var d = $(this);
										if(!d.hasClass('dropEnabled')){
											d.addClass('dropEnabled')
											d.droppable(
												{
													drop	: function(event, ui) {
														var clone = ui.draggable.clone();
														ui.draggable.before(clone);
														return o._merge(ui.draggable, d, clone);
													},
													hoverClass	: 'isReceiving',
													accept		: '.isDraggable',
													tolerance	: 'intersect'
												}
											);
										}
										d.find('.box').append('<div class="overlay"><span class="vetology-drop-file"></span></div>');
									});
									$('body').addClass('draggingMerge');
									dragParent
										.addClass('isDragging')
										.find('.vetology-drop-file').attr('class', 'vetology-link');
								},
								stop	: function(event, ui){
									if(!dragParent.hasClass('beingDropped')){
										$('body')
											.removeClass('draggingMerge')
											.find('.isDroppable .overlay').remove();
										dragParent.removeClass('isDragging');
									}
								}
							}
						);
					}
				});
				$('.caseSetMerges .caseDrag').each(function(){
					var item = $(this);
					var droppable = item.closest('.IGotMerges');
					item.data('merges', 0);
					var merge = droppable.data('merge');
					var mergeItem = item.data('merge');
					jQuery.extend(merge, mergeItem);
					merge[item.data('item')] = item;
					droppable.data('merge', merge);
				});
			},
            _unLink: function(curTarget) {
			    const linkedCaseSpan = curTarget.parentElement.querySelector('span.linked-case');
                const mainCaseSpan = curTarget.parentElement.querySelector('span.main-case');
                const urlSpan = curTarget.parentElement.querySelector('span.url');
			    const mainCaseID = mainCaseSpan.textContent;
                const linkedCaseID = linkedCaseSpan.textContent;
                const unlinkUrl = urlSpan.textContent;

 			    const data = {
                    unmergeOn: mainCaseID,
                    mergeID: linkedCaseID
                };

			    $("body").Vetology("doRequest", "POST", data, unlinkUrl,
                    function(is) {
			            if (is.unmerged) {
			                // refresh page to update popover info
                            $(".isFilter").trigger("change");
                            setTimeout(() => {
                                $("body").Vetology("vetologyShowDialog", "Success:", "Cases successfully unlinked", "success");
                            }, 2000);
			            } else {
                            $("body").Vetology("vetologyShowDialog", is.reasonTitle, is.reason, "error");
                        }
                    }, "JSON", false, "Please wait while I unlink our case", "Please wait while I unlink our case<br>", "I am almost done");
            }
		}
	);
})(jQuery);
